import tailwindTheme from './../../tailwind.config';

const { colors } = tailwindTheme.theme.extend;

export const ACCENT_COLORS = {
  primary: colors.brand.accent,
  taupe: colors.taupe[2],
  ...colors.accent,
};

export const TEXT_COLORS = {
  primary: colors.taupe[3],
  secondary: colors.taupe[2],
  muted: colors.taupe[1],
};
